export default {"src":"/_next/static/media/45-icon.3609a965.svg","height":46,"width":40,"blurWidth":0,"blurHeight":0};